module.exports = __webpack_public_path__ + "static/arrow-down-disabled.df520da30ddbf4f72f2961a0d690f1b8.svg";